// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"project-funding-partner-m__wrapper__1TEvC","content":"project-funding-partner-m__content__5z8tC"};